// Convert file to data URL
export const fileToDataUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

// Upload image to temporary hosting service (using a free service like imgbb or similar)
export const uploadToTempStorage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    
    // Using imgbb as temporary storage (you'll need to get an API key)
    // For demo purposes, we'll create a blob URL
    const blobUrl = URL.createObjectURL(file);
    
    // In production, you'd want to use a proper temporary storage service
    // const response = await axios.post('https://api.imgbb.com/1/upload', formData, {
    //   params: {
    //     key: 'YOUR_IMGBB_API_KEY',
    //   },
    // });
    
    return {
      url: blobUrl,
      deleteUrl: null, // For cleanup later
    };
  } catch (error) {
    console.error('Error uploading to temporary storage:', error);
    throw error;
  }
};

// Validate image file
export const validateImageFile = (file) => {
  const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
  const maxSize = 10 * 1024 * 1024; // 10MB
  
  if (!validTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please use JPEG, PNG, GIF, or WebP.');
  }
  
  if (file.size > maxSize) {
    throw new Error('File too large. Please use images smaller than 10MB.');
  }
  
  return true;
};

// Download image from URL
export const downloadImage = async (url, filename = 'thumbnail.png') => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    
    // Create download link
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Cleanup
    URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('Error downloading image:', error);
    throw error;
  }
};

// Download image from URL with proper CORS handling
export const downloadImageFromUrl = async (url, filename = 'image.png') => {
  try {
    console.log('Downloading image from:', url);
    
    // Try to fetch with CORS
    const response = await fetch(url, {
      mode: 'cors',
      headers: {
        'Origin': window.location.origin
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const blob = await response.blob();
    
    // Create download link
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Cleanup
    URL.revokeObjectURL(downloadUrl);
    
    console.log('Download completed successfully');
  } catch (error) {
    console.error('Error downloading image:', error);
    // Fallback: open in new tab if direct download fails
    window.open(url, '_blank');
  }
};

// Create image element from URL
export const createImageElement = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
};
